import { render, staticRenderFns } from "./publicFooter.vue?vue&type=template&id=22ddedca&scoped=true"
import script from "./publicFooter.vue?vue&type=script&lang=js"
export * from "./publicFooter.vue?vue&type=script&lang=js"
import style0 from "./publicFooter.vue?vue&type=style&index=0&id=22ddedca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ddedca",
  null
  
)

export default component.exports